import React from 'react';

import Button from '@atlaskit/button/new';
import Form from '@atlaskit/form/form';
import Field from '@atlaskit/form/field';
import { FormFooter } from '@atlaskit/form/form-footer';
import RadioGroup from '@atlaskit/radio/radio-group';
import { type OptionsPropType } from '@atlaskit/radio/types';

interface FormData {
	[key: string]: string;
	'radio-group-invalid': string;
}

const validateOnSubmit = (data: FormData) => {
	let errors;
	errors = requiredValidator(data, 'radio-group-invalid');
	return errors;
};

const requiredValidator = (data: FormData, key: string) => {
	if (data[key] === 'invalid') {
		return {
			[key]: `This field is invalid.`,
		};
	}
};

const options: OptionsPropType = [
	{ name: 'radio-group-invalid', value: 'valid', label: 'Valid' },
	{ name: 'radio-group-invalid', value: 'invalid', label: 'Invalid' },
];

export default function RadioInvalid(): React.JSX.Element {
	return (
		<Form<FormData>
			onSubmit={(data) => {
				console.log('form data', data);
				return Promise.resolve(validateOnSubmit(data));
			}}
		>
			<Field
				label="Radio group with validation"
				name="radio-group-invalid"
				defaultValue="valid"
				component={({ fieldProps }) => <RadioGroup {...fieldProps} options={options} />}
			/>
			<FormFooter>
				<Button type="submit">Submit</Button>
			</FormFooter>
		</Form>
	);
}
